import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Data
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const res = await axios.get("https://allyoutube-01-02d59d78beb5.herokuapp.com/api/footer-section");
        setFooterData(res.data.data);
      } catch (err) {
        console.error("Failed to fetch footer data", err);
        setError("Failed to load footer.");
      } finally {
        setLoading(false);
      }
    };
    fetchFooterData();
  }, []);

  if (loading) return null; // Hide footer while loading to prevent layout shift
  if (error || !footerData) return null;

  return (
    <>
      <footer className="footer-section">
        {/* --- Dynamic Top Section (Contact Info) --- */}
        <div className="footer-top">
          <div className="container">
            <div className="row g-3 justify-content-center g-lg-0">
              {footerData.contactInfo.map((item, index) => (
                <div key={index} className="col-lg-4 col-sm-6 col-12">
                  <div className="footer-top-item lab-item">
                    <div className="lab-inner">
                      <div className="lab-thumb">
                        <img src={item.icon} alt="icon" />
                      </div>
                      <div className="lab-content">
                        <span>{item.label}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* --- Dynamic Middle Section (Logo, Desc, Social) --- */}
        <div
          className="footer-middle padding-top padding-bottom"
          style={{ backgroundImage: `url(${footerData.middleSection.backgroundImage})` }}
        >
          <div className="container">
            <div className="row padding-lg-top">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item mb-lg-0">
                    <div className="fm-item-title mb-4">
                      <img src={footerData.middleSection.logo} alt="logo" />
                    </div>
                    <div className="fm-item-content">
                      <p className="mb-4">{footerData.middleSection.description}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item-3 mb-lg-0">
                    <div className="fm-item-title">
                      <h4>{footerData.middleSection.socialSection.title}</h4>
                    </div>
                    <div className="fm-item-content">
                      <p>{footerData.middleSection.socialSection.description}</p>
                      <ul className="match-social-list d-flex flex-wrap align-items-center">
                        {footerData.middleSection.socialSection.socialIcons.map((social, index) => (
                          <li key={index}>
                            <a href={social.url} target="_blank" rel="noreferrer">
                              <img src={social.icon} alt={social.name} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- Dynamic Bottom Section (Copyright) --- */}
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom-content text-center">
                  <p dangerouslySetInnerHTML={{ __html: footerData.copyrightText }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;